// Translations
import landing from '../views/landing/translations/ar'

// Translation: Reset (Arabic)
export default Object.freeze({
	name: 'إعادة تعيين',
	views: { landing }
})
